import { Icon, Tooltip } from '@chakra-ui/react';
import { PiCheckCircle, PiWarningCircle } from 'react-icons/pi';
import {
  UserAvatarStatus,
  UserFaceIdStatus,
} from '../../../../../models/users';

enum FaceIdStatusBadgeColor {
  EMPTY = 'gray.400',
  VALID = 'green.400',
  INVALID = 'red.400',
  NOT_VERIFIED = 'gray.400',
  UNAVAILABLE = 'gray.400',
}

enum AvatarStatusTooltipLabel {
  EMPTY = 'Sem foto',
  VALID = 'Foto válida',
  INVALID = 'Foto inválida',
  NOT_VERIFIED = 'Foto não verificada',
  UNAVAILABLE = 'FaceID desativado',
}

interface IFaceIdStatusBadgeProps {
  faceIdStatus: UserFaceIdStatus;
  avatarStatus: UserAvatarStatus;
}

const FaceIdStatusBadge = ({
  faceIdStatus,
  avatarStatus,
}: IFaceIdStatusBadgeProps): JSX.Element => (
  <Tooltip
    placement="bottom"
    hasArrow
    label={
      faceIdStatus === UserFaceIdStatus.ENABLED
        ? AvatarStatusTooltipLabel[avatarStatus]
        : 'FaceID desativado'
    }
  >
    <span>
      <Icon
        as={
          faceIdStatus === UserFaceIdStatus.ENABLED
            ? PiCheckCircle
            : PiWarningCircle
        }
        color={
          faceIdStatus === UserFaceIdStatus.ENABLED
            ? FaceIdStatusBadgeColor[avatarStatus]
            : 'yellow.400'
        }
        fontSize={26}
        cursor="pointer"
      />
    </span>
  </Tooltip>
);

export default FaceIdStatusBadge;
